// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import { ElMessage } from 'element-ui'
import 'element-ui/lib/theme-chalk/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipBoard from 'vue-clipboard2'
import { Message } from 'element-ui'
import App from './App'
import router from './router'
import storage from 'store'
import api from '@/api'
import store from './store'
import axios from 'axios'
import SkuForm from 'vue-sku-form'

Vue.prototype.storage = storage
// 历史遗留: 大量页面把 https://time.api.boyalife.cn 写死在 url 里, 不走 baseURL,
// 靠这个拦截器在运行时统一改写。
// 判据用「配的 API 地址是不是正式」而不是 NODE_ENV —— 之前用后者, 一旦测试站
// 误用 build:pro 打包, 改写就整个失效, 测试后台会直接读写正式库。
const API_BASE = process.env.VUE_APP_API_BASE_URL;
const PROD_API = "https://time.api.boyalife.cn";
if (API_BASE && API_BASE !== PROD_API) {
  // 添加请求拦截器
  axios.interceptors.request.use(config => {
    config.url = String(config.url).replace(PROD_API, API_BASE);
    return config;
  });
}
Vue.prototype.axios = axios

Vue.prototype.$api = api
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
  fullscreenEl: true, //控制是否显示右上角全屏按钮
  arrowEl: true,
  arrowKeys: true,
  closeEl: true, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: true, //控制是否显示放大缩小按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  tapToToggleControls: false, //点击应切换控件的可见性
  clickToCloseNonZoomable: true, //点击图片应关闭图库，仅当图像小于视口的大小时
  indexIndicatorSep: ' / '//图片数量的分隔符
}
Vue.use(preview, options)
Vue.use(preview)
Vue.use(SkuForm)


// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
Vue.use(VueClipBoard)
Vue.config.productionTip = false

/* eslint-disable no-new */
let that = this
axios.interceptors.response.use(res => {
  let code = res && res.data && res.data.code
  if (code == 401) {
    // 原写法在成功分支里引用了未定义的 error 变量，会抛 ReferenceError
    const msg = (res.data.error && res.data.error.message) || '登录已失效，请重新登录'
    Message.error(msg)
    storage.clearAll()
    setTimeout(() => {
      router.replace({ path: '/login' })
    })
    return false
  }
  return res
}, error => {
  // 网络错误/超时时 error.response 不存在，原写法直接取 .data.code 会抛 TypeError，
  // 连 Promise.reject 都执行不到，页面表现为“点了完全没反应”
  const code = error && error.response && error.response.data && error.response.data.code
  if (code == 401) {
    const msg = (error.response.data.error && error.response.data.error.message) || '登录已失效，请重新登录'
    Message.error(msg)
    storage.clearAll()
    setTimeout(() => {
      router.replace({ path: '/login' })
    })
    return false
  }
  return Promise.reject(error)
})
router.beforeEach((to, from, next) => {
  if(to.meta.title){//判断是否有标题
    document.title = '博雅时光机 - ' + to.meta.title
  }
  // if (whiteRouter.indexOf(this.$route.path) !== -1) {
  //   console.log(to)
  //   window.location.href = to.fullPath
  //   next()
  // } else {
  //   next()
  // }
  if (to.path == '/') return next()
  if (!storage.get('__token')) return next('/')
  next()
})

const vueApp = new Vue({
  router,
  store,
  mounted() {},
  render: h => h(App)
})
vueApp.$mount('#app')
